import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=1210128e&"
import script from "./pageFooter.vue?vue&type=script&lang=js&"
export * from "./pageFooter.vue?vue&type=script&lang=js&"
import style0 from "./pageFooter.vue?vue&type=style&index=0&id=1210128e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports